import DataGrid2 from '../..';

export const onEditCanceling = function (this: DataGrid2) {
	this.pendingEdit = false;
};
